// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Info';

export function InfoStroke() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
      role="img"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 8V6H13V8H11ZM11 18V10H13V18H11Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function InfoFilled() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label={TITLE}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 8V6H13V8H11ZM11 18V10H13V18H11Z"
        fill="currentColor"
      />
    </svg>
  );
}
